import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { ColumnMappedByCompanyListModel } from 'src/Models/GetColumnMappedByCompanyListPaged';
import { InrollProductsCompanyModel } from 'src/Models/InrollProductsCompanyModel';
import { LifelineNLADClaimService } from 'src/Services/nladClaim.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-mapped-column-lifeline-listing',
  templateUrl: './mapped-column-lifeline-listing.component.html',
  styleUrls: ['./mapped-column-lifeline-listing.component.css']
})
export class MappedColumnLifelineListingComponent implements OnInit {
  listOfData: ColumnMappedByCompanyListModel[];
  listOfExportData: ColumnMappedByCompanyListModel[]
  filterModel = new FilterModel();
  SelectedTool: string;
  productId: number = 1;
  providerId: number = 0;
  userId: number = 0;

  isAscending: boolean = false
  upDowFileNameCSS: string = '';
  upDowCompanyNameCSS: string = '';
  upDowCreatedDateCSS: string = '';


  totalRecordsCount: number = -1;
  isloading: boolean = false;
  currentPage: number = 1;

  listOfInrollProductCompany: InrollProductsCompanyModel[];
  dropdownCompanies = [];
  selectedItemsCompanies = [];
  dropdownSettingCompanies = {};
  listOfCompany = [];

  deleteProviderId = 0;
  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly titleService: Title,
    private readonly nladService: LifelineNLADClaimService,
    private readonly toastr: ToastrService,
      private sessionStorageService: SessionStorageService
  ) {
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Lifeline Claim Files Columns Mappings');
    this.productId = ToolEnum[this.SelectedTool];
    this.providerId = 0;
    this.userId = this.sessionStorageService.getAdminUserId();
    this.filterModel.providerId = this.providerId.toString();
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'CompanyName';
  }
  ngOnInit() {
    this.GetLifelineColumnMappedByCompanyListPaged();
    this.GetInrollClientCompany();
  }

  GetLifelineColumnMappedByCompanyListPaged() {
    this.isloading = true;
    this.listOfData = [];
    this.filterModel.IsExport = false;
    this.nladService.GetLifelineColumnMappedByCompanyListPagedV2(this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfData = data.listOfData;
          if (this.listOfData != null) {
            if (this.listOfData.length > 0) {
              this.totalRecordsCount = this.listOfData[0].totalRecordCount;
            }
            else {
              this.totalRecordsCount = 0;
            }
          }
          else {
            this.totalRecordsCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetLifelineColumnMappedByCompanyListPaged();
  }

  sort(sortBy: any) {
    this.upDowFileNameCSS = '';
    this.upDowCompanyNameCSS = '';
    this.upDowCreatedDateCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "fileName") {
        this.upDowFileNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "fileName") {
        this.upDowFileNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetLifelineColumnMappedByCompanyListPaged();
  }

  GetInrollClientCompany() {
    this.nladService.GetLifelineInrollClientCompanyV2().subscribe(
      data => {
        this.dropdownSettingCompanies = {
          singleSelection: true,
          text: 'Filter by Company',
          enableSearchFilter: true,
          classes: 'borderLessTextBoxGreen',
          badgeShowLimit: 1,
          noDataLabel: 'No company',
          showCheckbox: false,
          enableFilterSelectAll: false
        };

        if (data != null) {
          if (data.status == 'Success') {
            this.listOfInrollProductCompany = data.listofInrollCompany;
            if (this.listOfInrollProductCompany != null) {
              if (this.listOfInrollProductCompany.length > 0) {
                for (let iCounter = 0; iCounter < this.listOfInrollProductCompany.length; iCounter++) {
                  this.dropdownCompanies.push({ 'id': this.listOfInrollProductCompany[iCounter].companyId, 'itemName': this.listOfInrollProductCompany[iCounter].companyName });
                }
              }
            }
          }
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onSelectedCompanies($event) {

    this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, $event.id)
    this.listOfCompany.push($event.id);
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event.id;
    this.GetLifelineColumnMappedByCompanyListPaged();
  }

  onDeSelectedCompanies($event) {
    if (this.listOfCompany != null) {
      if (this.listOfCompany.length > 0) {
        this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, $event.id)
      }
    }
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event.id;
    this.GetLifelineColumnMappedByCompanyListPaged();
  }

  onSelectAllCompanies($event) {
    for (const item of $event) {
      if (this.listOfCompany != null) {
        if (this.listOfCompany.length > 0) {
          this.listOfCompany = this.removeElemetninArrayById(this.listOfCompany, item.id)
          this.listOfCompany.push(item.id);
        }
        else {
          this.listOfCompany.push(item.id);
        }
      }
    }
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = $event[0].id;
    this.GetLifelineColumnMappedByCompanyListPaged();
  }

  onDeSelectAllCompanies($event) {
    this.listOfCompany = [];
    this.filterModel.pageNumber = '1';
    this.filterModel.providerId = '0';
    this.GetLifelineColumnMappedByCompanyListPaged();
  }

  removeElemetninArrayById(array, element) {
    return array.filter(e => e.id !== element);
  }

  redirectToColumnMappingPage(providerId) {
    this.router.navigate(['/admin/inroll/column/lifeline-mapping/' + providerId]);
  }

  mappedLifelineColumnDelete(providerId) {
    this.nladService.MappedLifelineColumnDelete(providerId).subscribe(
      data => {
        if (data != null) {
          if (data.id > 0) {
            this.toastr.success('Record Delete Successfully', 'Success');
            this.GetLifelineColumnMappedByCompanyListPaged();
          }
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  setDeleteId(providerId) {
    this.deleteProviderId = providerId
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportColumnsMappings() {
    this.isloading = true;
    this.listOfExportData = [];
    this.filterModel.IsExport = true;
    this.nladService.GetLifelineColumnMappedByCompanyListPagedV2(this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfExportData = data.listOfData;
          if (this.listOfExportData != null) {
            if (this.listOfExportData.length > 0) {
              setTimeout(() => {
                this.DownloadColumnsMappings();
                this.isloading = false;
              }, 2000);
            }
            else {
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadColumnsMappings() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportInrollLifelineClaimFilesColumnsMappings';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportInrollLifelineClaimFilesColumnsMappings.xls");
  }
}